import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  section: {
    width: '100%',
    paddingTop: theme.spacing(1),
    marginBottom: theme.spacing(-2),
  },
  sectionWrapper: {
    width: '100%',
    paddingTop: theme.spacing(1),
  },
  customWrapper: {
    width: '100%',
    display: 'flex',
    gap: theme.spacing(1),
  },
  dimensionBox: {
    paddingBottom: theme.spacing(3),
  },
  dimensionWrapper: {
    paddingTop: theme.spacing(3),
    width: '100%',
  },
  subTitle: {
    fontSize: '16px',
    color: theme.palette.textField.dark,
    lineHeight: theme.spacing(3),
  },
  subscriptionRow: {
    paddingBottom: theme.spacing(1),
  },
  createdAtWrapper: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  createdAtDate: {
    fontSize: '14px',
    color: theme.palette.labraText.tertiary,
    lineHeight: theme.spacing(2.5),
  },
  createdAtTime: {
    fontSize: '14px',
    color: theme.palette.labraText.description,
    lineHeight: theme.spacing(2.5),
  },
  subscriptionEndDate: {
    padding: theme.spacing(2, 0),
  },
  dateTimeWrapper: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  infoValue: {
    fontSize: '14px',
    lineHeight: theme.spacing(2.5),
  },
}))
